<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.1758 8.06384C21.5977 9.54041 21.5977 12.7045 21.5977 12.7045C21.5977 12.7045 21.5977 15.8334 21.1758 17.3451C20.9648 18.1888 20.2969 18.8217 19.4883 19.0326C17.9766 19.4193 12 19.4193 12 19.4193C12 19.4193 5.98828 19.4193 4.47656 19.0326C3.66797 18.8217 3 18.1888 2.78906 17.3451C2.36719 15.8334 2.36719 12.7045 2.36719 12.7045C2.36719 12.7045 2.36719 9.54041 2.78906 8.06384C3 7.22009 3.66797 6.55212 4.47656 6.34119C5.98828 5.91931 12 5.91931 12 5.91931C12 5.91931 17.9766 5.91931 19.4883 6.34119C20.2969 6.55212 20.9648 7.22009 21.1758 8.06384ZM10.0312 15.5521L15.0234 12.7045L10.0312 9.85681V15.5521Z"
            fill="inherit"
        />
    </svg>
</template>
